import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
} from "@material-ui/core";
import { toast } from "react-toastify";

const alerta = {
  fontSize: 12,
  color: "#92400e",
  background: "#fffbeb",
  border: "1px solid #fde68a",
  borderRadius: 8,
  padding: 8,
};

const FlowBuilderEditedMessageModal = ({ open, onSave, onUpdate, data, close }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [textoInicial, setTextoInicial] = useState("");
  const [textoFinal, setTextoFinal] = useState("");
  const [segundos, setSegundos] = useState(4);
  const [comoFunciona, setComoFunciona] = useState(false);

  useEffect(() => {
    if (open === "edit") {
      setTextoInicial(data?.textoInicial || "");
      setTextoFinal(data?.textoFinal || "");
      setSegundos(Number(data?.segundos) || 4);
      setActiveModal(true);
    } else if (open === "create") {
      setTextoInicial("");
      setTextoFinal("");
      setSegundos(4);
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    const a = String(textoInicial || "").trim();
    const b = String(textoFinal || "").trim();

    if (!a || !b) {
      toast.error("Preencha as duas mensagens.");
      return;
    }
    if (a === b) {
      toast.error("Os dois textos são iguais — não haveria edição nenhuma.");
      return;
    }
    const s = parseInt(segundos, 10);
    if (!s || s < 1 || s > 60) {
      toast.error("A espera precisa ficar entre 1 e 60 segundos.");
      return;
    }

    const payload = { textoInicial: a, textoFinal: b, segundos: s };

    if (open === "edit") {
      onUpdate({ ...data, ...payload });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  return (
    <Dialog open={activeModal} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Mensagem editada</DialogTitle>
      <DialogContent>
        <Box>
          <TextField
            label="1ª mensagem (a que vai ser corrigida)"
            placeholder="Ex.: Oi, tudo bem? O valor é R$ 100,00"
            variant="outlined"
            margin="dense"
            fullWidth
            multiline
            minRows={2}
            value={textoInicial}
            onChange={(e) => setTextoInicial(e.target.value)}
          />

          <TextField
            label="2ª mensagem (como fica depois da edição)"
            placeholder="Ex.: Oi, tudo bem? O valor é R$ 97,00"
            variant="outlined"
            margin="dense"
            fullWidth
            multiline
            minRows={2}
            value={textoFinal}
            onChange={(e) => setTextoFinal(e.target.value)}
          />

          <TextField
            label="Esperar quantos segundos antes de editar"
            type="number"
            variant="outlined"
            margin="dense"
            fullWidth
            value={segundos}
            onChange={(e) => setSegundos(e.target.value)}
            inputProps={{ min: 1, max: 60 }}
          />

          <Box style={{ marginTop: 10 }}>
            <Button size="small" onClick={() => setComoFunciona(!comoFunciona)}>
              {comoFunciona ? "Ocultar" : "Como funciona?"}
            </Button>
          </Box>

          {comoFunciona && (
            <Box style={{ marginTop: 10 }}>
              <Typography style={{ fontSize: 12, color: "#4b5563", lineHeight: 1.65 }}>
                O cliente recebe a 1ª mensagem, e depois dos segundos escolhidos ela
                muda para a 2ª — com a marca <b>"editada"</b> do WhatsApp, igual a
                quando uma pessoa se corrige. Serve para o atendimento parecer humano.
              </Typography>
              <Typography style={{ ...alerta, marginTop: 10 }}>
                Só funciona na conexão <b>não oficial</b> (QR Code). A API oficial da
                Meta não permite editar mensagem já enviada — nessas conexões o cliente
                recebe direto a 2ª mensagem, sem a edição.
              </Typography>
              <Typography style={{ ...alerta, marginTop: 8 }}>
                A espera vai até 60 segundos. Para pausas maiores, use o bloco de
                intervalo: ele grava o agendamento e sobrevive a reinício do sistema.
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderEditedMessageModal;
